/* eslint-disable operator-linebreak */
import React from 'react';
import PropTypes from 'prop-types';
import getPercentageForProgressBar from '../../helpers/getPercentageForProgressBar';

const HIDDEN_PATHS = new Set(['/', '/warranty-agreement', '/support', '/check-lease']);

const ACTIVE_STEPS_BY_PATH = {
  '/pay-check-details': [1],
  '/display-offered-lease-details': [1, 2],
  '/price-tag-disclosures': [1, 2, 3],
  '/lease-agreement': [1, 2, 3, 4],
  '/checkout': [1, 2, 3, 4, 5],
};

export default function RoundBreadcrumbs({ active = [], excludeFirst = false, location }) {
  if (HIDDEN_PATHS.has(location?.pathname)) {
    return null;
  }
  if (ACTIVE_STEPS_BY_PATH[location?.pathname]) {
    active = [...ACTIVE_STEPS_BY_PATH[location.pathname]];
  }
  // Only the paths above (or an explicit `active`) show the stepper; anywhere else it stays hidden.
  if (!active.length) {
    return null;
  }
  const setClassName = index => {
    const hasActiveClass = active && active.indexOf(index + 1) !== -1 ? 'active' : '';
    const hasCurrent = index === active.length - 1 ? 'current' : '';
    return `${hasActiveClass} ${hasCurrent}`;
  };
  const items = ['Income', 'Offer', 'Pricing', 'Agreement', 'Payment'];
  if (excludeFirst) {
    items.shift();
    active.shift();
    active = active.map(el => el - 1);
  }
  const getWrapperClass = () => {
    if (excludeFirst) {
      return 'k-rounded-breadcrumbs k-rounded-breadcrumbs-exclude';
    }
    return 'k-rounded-breadcrumbs';
  };
  return (
    <div className={getWrapperClass()}>
      <section className="k-breadcrumbs-wrapper" style={{ height: active.length ? '75px' : '0px' }}>
        <div className="k-breadcrumbs-progress" style={{ width: getPercentageForProgressBar(active, items.length) }} />
        <ul className="k-breadcrumbs">
          {items.map((el, index) => (
            <li
              key={el}
              data-breadcrumbs-number={index + 1}
              className={setClassName(index)}
              style={{ width: `${100 / items.length}%` }}
            >
              {el}
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}

RoundBreadcrumbs.propTypes = {
  active: PropTypes.array,
  excludeFirst: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};
